import { FlowActionTypes } from '../store/flow/action-types';
import { isPostVerification } from '../flow-settings/settingsSelectors';
import { postVerificationFlowSet, clearCompletedSteps, setInitialFlow } from '../store/flow/action-creators';
import { getFlowBranches } from '../flow-branches/getFlowBranches';
import { setIsNewUser } from '../store/app/action-creators';
export const InitialFlowMiddleware = store => next => action => {
  const dispatchResult = next(action);
  if (action.type === FlowActionTypes.Load || action.type === FlowActionTypes.Reload) {
    if (action.type === FlowActionTypes.Reload) {
      const branches = getFlowBranches();
      branches.forEach(branch => {
        branch.processed = false;
        branch.processedOnStep = null;
      });
    }
    store.dispatch(setInitialFlow());
    if (isPostVerification()) {
      store.dispatch(setIsNewUser(true));
      store.dispatch(postVerificationFlowSet());
    }
    store.dispatch(clearCompletedSteps());
  }
  return dispatchResult;
};